export var callbackByLocale = {
  "da-DK": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/da-DK.json"),
      });
    });
  },
  "de-DE": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/de-DE.json"),
      });
    });
  },
  "en-GB": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/en-GB.json"),
      });
    });
  },
  "en-US": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/en-GB.json"),
      });
    });
  },
  "es-ES": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/es-ES.json"),
      });
    });
  },
  "fi-FI": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/fi-FI.json"),
      });
    });
  },
  "fr-FR": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/fr-FR.json"),
      });
    });
  },
  "it-IT": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/it-IT.json"),
      });
    });
  },
  "nb-NO": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/no-NO.json"),
      });
    });
  },
  "nl-NL": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/nl-NL.json"),
      });
    });
  },
  "pt-PT": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/pt-PT.json"),
      });
    });
  },
  "sv-SE": function (callback) {
    require.ensure([], function (require) {
      callback({
        messages: require("../../locales/sv-SE.json"),
      });
    });
  },
};

export default function loadMessagesForLocale(locale, callback) {
  if (Object.keys(callbackByLocale).indexOf(locale) !== -1) {
    return callbackByLocale[locale](({ messages }) => {
      return callback(null, { messages });
    });
  } else {
    return callback(new Error('Unsupported locale "' + locale + '".'));
  }
}
